var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBusinessLookupMobileNav(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.88281 13.9615V6.06923M11.6719 13.9615V6.06923M6.32812 5.63077V3.87692C6.32812 3.39261 6.72687 3 7.21875 3H10.3359C10.8278 3 11.2266 3.39261 11.2266 3.87692V5.63077M3.65625 14.4H14.3438C15.3275 14.4 16.125 13.6148 16.125 12.6462V7.38462C16.125 6.41599 15.3275 5.63077 14.3438 5.63077H3.65625C2.67249 5.63077 1.875 6.41599 1.875 7.38462V12.6462C1.875 13.6148 2.67249 14.4 3.65625 14.4Z",
    stroke: "#080917",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBusinessLookupMobileNav);
export default __webpack_public_path__ + "static/media/business-lookup-mobile-nav.78c8619272d67db0ad4edee076b287b5.svg";
export { ForwardRef as ReactComponent };